import type { PropsWithChildren } from 'react'
import styled from 'styled-components'

import type { SingleSubStore } from '../../store/subStore'

import { EmptyPage } from '../exception/EmptyPage'
import { ErrorPage } from '../exception/ErrorPage'
import { Spinner } from '../spinner/Spinner'

interface DetailContentProps {
  detailStore: SingleSubStore<any>
}

export function DetailContent({ detailStore, children }: PropsWithChildren<DetailContentProps>) {
  return (
    <>
      {detailStore.isLoading || !detailStore.isLoaded ? (
        <SpinnerContainer>
          <Spinner />
        </SpinnerContainer>
      ) : detailStore.isFailed ? (
        <ErrorPage />
      ) : detailStore.isNotFound ? (
        <EmptyPage />
      ) : (
        children
      )}
    </>
  )
}

const SpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`
